import { useEffect, useState } from 'react';
import { Box, CircularProgress, Stack } from '@mui/material';
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';
import liff from '@line/liff';
import Identification from './identification';

/**
 * 新本人登録
 */
export default function Registration(params: { liffId?: string }) {
  const search = useLocation().search;
  const query = queryString.parse(search);
  const [staffCode, setStaffCode] = useState<string>();
  const [branch, setBranch] = useState<string | null | undefined>();

  useEffect(() => {
    document.title = '本人登録';

    const branch =
      String(query['branch']) === 'shinjuku-cs' ||
      String(query['branch']) === 'engineering'
        ? String(query['branch'])
        : 'default';
    setBranch(branch);
  }, [query]);

  useEffect(() => {
    // CS東京、エンジニアリング以外は新本人登録認証
    if (branch === 'default') {
      // RS-Webの本人登録認証にリダイレクトする
      if (!query['staffCode'] && query['authLiffId']) {
        window.location.href = `https://liff.line.me/${query['authLiffId']}?redirectLiffId=${params.liffId}`;
      } else if (query['staffCode']) {
        setStaffCode(query['staffCode'] as string);
      }
    }
  }, [branch]);

  useEffect(() => {
    let closeTimerId: number | undefined;

    (async () => {
      // staffCodeが返ってきたらメッセージを送信
      if (staffCode) {
        const text = `[本人登録]\nスタッフコード: ${staffCode}`;
        try {
          // メッセージを送信してLIFFを閉じる
          await liff.sendMessages([{ type: 'text', text }]);
          if (liff.isInClient()) {
            liff.closeWindow();
          }
        } catch (error) {
          console.error('Failed to send LIFF message:', error);
          closeTimerId = window.setTimeout(() => {
            if (liff.isInClient()) {
              liff.closeWindow();
            }
          }, 5000);
        }
      }
    })();

    return () => {
      if (closeTimerId) {
        window.clearTimeout(closeTimerId);
      }
    };
  }, [staffCode]);

  return (
    <>
      {branch === 'default' ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', paddingTop: 8 }}>
          {!staffCode ? (
            <CircularProgress />
          ) : (
            <Stack spacing={1}>
              <p>本人登録が完了しました。</p>
              <p>スタッフコード: {staffCode}</p>
              <p style={{ marginTop: '16px' }}>
                認証完了後、メニューに切り替えまでに1～2分のお時間を要する場合があります。
                <br />
                切り替わらない場合はアプリの再起動をお試しください。
              </p>
              <p style={{ marginTop: '16px' }}>5秒後に自動で閉じます。</p>
              <p>※自動で閉じない場合は右上の[×]ボタンで閉じてください。</p>
            </Stack>
          )}
        </Box>
      ) : (
        <Identification />
      )}
    </>
  );
}
